import UserListPage from "../features/company-users/screens/UserList";
import RoutingUserList from "../features/company-users/screens/RoutingUserList";
import CompanyUserForm from "../features/company-users/screens/CompanyUserForm";

export const companyUserRoutes = [
  { path: "company-user/user-list", element: <UserListPage /> },
  { path: "company-user/routing-user-list", element: <RoutingUserList /> },
  { path: "company-user/create-user", element: <CompanyUserForm /> },
  { path: "company-user/update-user", element: <CompanyUserForm /> },
  { path: "company-user/view-user/:userId", element: <CompanyUserForm /> },
  { path: "company-user/update-user/:userId", element: <CompanyUserForm /> },
];
